import { Divider, Grid, styled, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import moment from 'moment';
import React from 'react';
import { useLocation } from 'react-router-dom';
import errorPage from '../../assets/images/errorPage.jpg';
import { useLoaderContext } from '../../contexts/LoaderContext';
import { VdsButton } from '../../vds';
import { StyledTitle } from '../../components/StyledTitle';
import { StyledDescription } from '../../components/StyledDescription';

export const ErrorPage: React.FC = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up(970));
    const { state } = useLocation();
    const setLoader = useLoaderContext();
    const urlParams = new URLSearchParams(window.location.search);
    const queryToken = urlParams.get("token");

    const code = state?.code || 404;
    const token = queryToken || state?.token || null;

    React.useEffect(() => {
        setLoader(false);
    }, []);

    return (
        <Grid height="100%" container>
            {matches && (
                <Grid sm={5} sx={{ backgroundColor: '#E5EAF0', display: 'flex', alignItems: 'center', justifyContent: 'center' }} item>
                    <img src={errorPage} width="300" alt='genericPage' />
                </Grid>
            )}
            <Grid
                sm={matches ? 7 : 12}
                item
            >
                <Box
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                    gap={2}
                    overflow="auto"
                    height="100%"
                >
                    <StyledTitle>
                        ATTENZIONE!
                    </StyledTitle>
                    <Divider orientation="horizontal" />
                    <StyledDescription>
                        Codice errore: {code} ({moment(new Date()).format('GG/MM/YYYY - HH:mm:ss')})
                        <br />
                        <br />
                        Si &egrave; verificato un problema con il caricamento di questa pagina
                        <br />
                        <br />
                        Se il problema persiste contatta <a target="_blank" style={{ textDecoration: 'none' }} href="https://mysupport.teamsystem.com" rel='noreferrer'>My Support</a>
                    </StyledDescription>
                    <Box px={4}>
                        {code === "520" && (
                            <VdsButton
                                variant="outlined"
                                color="secondary"
                                onClick={() => {
                                    window.location.href = window.location.origin + "?token=" + token + "&clear=true";
                                }}
                                sx={{
                                    width: '100px'
                                }}
                            >
                                Logout
                            </VdsButton>
                        )}
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};
